import { Fragment, useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Target } from 'react-feather';
import ProjectContext from '../../../_helper/Project';
import CustomizerContext from '../../../_helper/Customizer';
import { H6, P } from '../../../AbstractElements';

import {
    getAllPrograms,
    setProgram,
} from "../../../store/slices/programsSlice";


const Project = () => {
    const dispatch = useDispatch();
    const { layoutURL } = useContext(CustomizerContext);
    const [activeTab, setActiveTab] = useState('1');
    const { allData } = useContext(ProjectContext);

    const client = useSelector((state) => state.clients.selectedClient.value);
    const { programsData, count } = useSelector(
        (state) => state.programs?.programs ?? { programsData: [], count: 0 }
    );

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 4,
    });
    const [totalCount, setCount] = useState(0);
    const getPrograms = async (payload) => {
        dispatch(getAllPrograms(payload));
    };
    const visiblePages = 5;
    const totalPages = Math.ceil(totalCount / pagination.pageSize);
    const start = Math.max(0, pagination.pageIndex - Math.floor(visiblePages / 2));
    const end = Math.min(Math.ceil(totalCount / pagination.pageSize), start + visiblePages);

    useEffect(() => {
        setCount(count);
    }, [programsData, count]);

    useEffect(() => {
        getPrograms({
            pagination: true,
            limit: pagination.pageSize,
            offset: pagination.pageSize * pagination.pageIndex,
        });
    }, [pagination]);

    return (
        <Fragment>
            {/* <Breadcrumbs parent="Project" title="Project List" mainTitle="Project List" /> */}
            <Container fluid={true}>
                <Row className="project-card">
                    <Col md="12" className="project-list">
                        <Card>
                            <Row>
                                <Col md="6">
                                    <Nav tabs className="border-tab">
                                        <NavItem><NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')}><Target />All Plans</NavLink></NavItem>
                                        {/* <NavItem><NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => { setActiveTab('2')}}><Info />Imperia</NavLink></NavItem> */}
                                        {/* <NavItem><NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => { setActiveTab('3'); getCustomers(5); }}><CheckCircle />Infinti</NavLink></NavItem> */}
                                    </Nav>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Row key={pagination?.pageIndex}>
                                            {programsData?.map((item, i) =>
                                                <Col className='col-xxl-4 bordered-col' md='6' key={i}>
                                                    <div className='project-box'>
                                                        <span className={`badge ${item.badge === 'Done' ? 'badge-success' : 'badge-primary'}`}>{item.badge}</span>
                                                        <H6>{item?.name}</H6>
                                                        <div className='media'>
                                                            <div className='media-body'>
                                                                <P>{item?.slug_name ? item?.slug_name : 'N/A'} | {item?.status ? item?.status : 'N/A'}</P>
                                                            </div>
                                                        </div>
                                                        <P>{item?.description}</P>
                                                        <Row className='details'>
                                                            <Col xs='6'>
                                                                <span>Customers:</span>
                                                            </Col>
                                                            <Col xs='6' className={item.badge === 'Done' ? 'font-success' : 'font-primary'}>
                                                                {item?.Customers ? item?.Customers?.length : 'N/A'}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>
                                        <Col xl="6" className="mx-auto">
                                            <CardBody className="flex justify-center items-center">
                                                <Pagination>
                                                    <PaginationItem disabled={pagination.pageIndex === 0}>
                                                        <PaginationLink onClick={() => setPagination(prev => ({ ...prev, pageIndex: 0 }))}>
                                                            First
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                    <PaginationItem disabled={pagination.pageIndex === 0}>
                                                        <PaginationLink onClick={() => setPagination(prev => ({ ...prev, pageIndex: prev.pageIndex - 1 }))}>
                                                            «
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                    {start > 0 && <PaginationItem disabled><PaginationLink>...</PaginationLink></PaginationItem>}
                                                    {Array.from({ length: end - start }, (_, i) => (
                                                        <PaginationItem active={start + i === pagination.pageIndex} key={start + i}>
                                                            <PaginationLink onClick={() => setPagination(prev => ({ ...prev, pageIndex: start + i }))}>
                                                                {start + i + 1}
                                                            </PaginationLink>
                                                        </PaginationItem>
                                                    ))}
                                                    {end < Math.ceil(totalCount / pagination.pageSize) && <PaginationItem disabled><PaginationLink>...</PaginationLink></PaginationItem>}
                                                    <PaginationItem disabled={(pagination.pageIndex + 1) * pagination.pageSize >= totalCount}>
                                                        <PaginationLink onClick={() => setPagination(prev => ({ ...prev, pageIndex: prev.pageIndex + 1 }))}>
                                                            »
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                    <PaginationItem disabled={pagination.pageIndex === totalPages - 1}>
                                                        <PaginationLink onClick={() => setPagination(prev => ({ ...prev, pageIndex: totalPages - 1 }))}>
                                                            Last
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                </Pagination>
                                            </CardBody>
                                        </Col>
                                    </TabPane>
                                    {/* <TabPane tabId="2">
                                        <Row>
                                            {allData.map((item, i) =>
                                            (item.badge === 'Doing' ?
                                                <CusClass item={item} key={i} />
                                                : '')
                                            )}
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            {allData.map((item, i) =>
                                            (item.badge === 'Done' ?
                                                <CusClass item={item} key={i} />
                                                : '')
                                            )}
                                        </Row>
                                    </TabPane> */}
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default Project;